import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { isManualReading } from 'helpers/externalDataSources';
import { isAggregatedPostMeal } from 'libs/StatsCalculations';
import ReadingFlagIcon from './ReadingFlagIcon';
import styles from './Marker.pcss';
const ReadingMarker = ({ key, reading, conversion, standards, className })=>{
    useStyles(styles);
    const { value } = reading;
    const toDisplay = conversion.toDisplay(value);
    const isManual = isManualReading(reading);
    const highConverted = isAggregatedPostMeal(reading.flags) ? conversion.toDisplay(standards.postMeal.highThreshold) : conversion.toDisplay(standards.preMeal.highThreshold);
    const lowConverted = isAggregatedPostMeal(reading.flags) ? conversion.toDisplay(standards.postMeal.lowThreshold) : conversion.toDisplay(standards.preMeal.lowThreshold);
    const isHigh = toDisplay > highConverted;
    const isLow = toDisplay < lowConverted;
    const isWithouthFlag = ![
        'Fasting',
        'PreMeal',
        'PostMeal'
    ].includes(reading.flags);
    const valueToDisplay = (+conversion.toDisplay(value)).toFixed(conversion.unit === 'MG_DL' ? 0 : 1);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(className, styles.markerReading, styles['markerReading--clip'], {
            [styles['markerReading--high']]: isHigh,
            [styles['markerReading--low']]: isLow,
            [styles['markerReading--isManual']]: isManual
        }),
        children: [
            /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                className: styles.markerReading__flag,
                flag: reading.flags
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.markerReading__value, {
                    [styles['markerReading__value--withoutFlag']]: isWithouthFlag
                }),
                children: [
                    " ",
                    valueToDisplay
                ]
            })
        ]
    }, key);
};
export default ReadingMarker;
